import React from "react";
import FourthsecOne from "../../assets/images/home-fourth-one.webp";
import FourthsecSecond from "../../assets/images/home-fourth-two.webp";
import FourthsecThird from "../../assets/images/home-fourth-three.webp";

const AmazingProcess = () => {
	return (
		<div>
			<div className="row">
				<div className="col-lg-12 text-center mt-4">
					<p className="f-30 f-mon-reg text-white mb-0">MY WINNING PROCESS</p>
					<p className="f-50 f-mon-bold text-white mb-0 lh-01">
						GET THE INSIDE INFO YOU NEED TO BECOME{" "}
						<span className="clr-e0">SUCCESSFUL SPORTS BETTORS</span>{" "}
					</p>
					<p className="f-50 f-mon-bold text-white lh-01 mt-1"></p>
					<div className="border-btm-pink-secondsec my-3"></div>
					<p className="wdth-80-per text-white f-mon-light f-20 mt-3">
						Updated odds, injury reports, player props, trends, motivations and
						most win games. Everything we need to determine who’s going to
						cover, win and pull the upset in one of the best sports betting
						prediction sites!{" "}
					</p>
				</div>
				<div className="col-lg-12">
					<div className="icons_second_sec mt-5 mb-5">
						<div className="text-center flx-1">
							<img
								className="img_home_fourth_sec"
								src={FourthsecOne}
								alt="fourth sec post"
							/>
							<p className="text-white f-mon-bold f-30">
								CHOOSE YOUR <span className="clr-e0">SPORT</span>
							</p>
						</div>
						<div className="text-center flx-1">
							<img
								className="img_home_fourth_sec"
								src={FourthsecSecond}
								alt="fourth sec post"
							/>
							<p className="text-white f-mon-bold f-30">
								LISTEN TO <span className="clr-e0">FAMOUS SPORTS BETTORS</span>{" "}
								ANALYSIS
							</p>
						</div>
						<div className="text-center flx-1">
							<img
								className="img_home_fourth_sec"
								src={FourthsecThird}
								alt="fourth sec post"
							/>
							<p className="text-white f-mon-bold f-30">
								BET & <span className="clr-e0">WIN BIG</span>
							</p>
						</div>
					</div>
				</div>
				<div className="col-lg-12"></div>
			</div>
		</div>
	);
};

export default AmazingProcess;
